var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDnaWeightManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4 113.4",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#20847B;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:1.0654;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,109.4c29.4,0,53.2-23.6,53.2-52.7C109.8,27.6,86,4,56.6,4S3.5,27.6,3.5,56.7 C3.5,85.8,27.3,109.4,56.6,109.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.2,81.4l-3.2-46.8c0,0-0.8-5.7,4.4-5.7s15.8,0,15.8,0s3.3-7.1,12-7.1S69.7,29,69.7,29h15.8 c0,0,4.3,0.3,3.9,5s-3.2,47.8-3.2,47.8s-0.1,3.7-4.8,3.7s-48.8,0-48.8,0S28.9,85.7,28.2,81.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.7,38.9H45.9c0,0-1-4.9,1.2-8.3c2.1-3.5,5.3-6,10.3-6s8.6,3,10.3,6.4S68.9,38.3,68.7,38.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 57.3,
    cy: 35.5,
    r: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 57.3,
    y1: 33.8,
    x2: 57.3,
    y2: 26.9
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnaWeightManagement);
export default __webpack_public_path__ + "static/media/DNA_Weight_Management.f4ac2c26757d57b2a84db0f3480be5ae.svg";
export { ForwardRef as ReactComponent };